import { Component, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from 'src/app/utils/services/dialog.service';
import { DataTableDirective } from 'angular-datatables';
import { DataTablesResponse } from 'src/app/interfaces/data-table-response.interface';
import { environment } from 'src/environments/environment';
import { BeneficiariService } from './beneficiari.service';
import { IBeneficiarInfo } from './beneficiari.interface';
import { helper } from 'src/environments/helper';
import Swal from 'sweetalert2';
import { InfoBeneficiarComponent } from './info-beneficiar/info-beneficiar.component';

@Component({
    selector: 'app-beneficiari',
    templateUrl: './beneficiari.component.html',
    styleUrls: ['./beneficiari.component.scss'],
})
export class BeneficiariComponent {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    isLoading = false;
    showCard = false;
    activeValue: string = '-1';
    publicValue: string = '-1';
    validatedValue: string = '-1';
    helper = helper;

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    parameters: { key: string; value: string }[] = [
        { key: '--Alegeți--', value: '-1' },
        { key: 'Da', value: '0' },
        { key: 'Nu', value: '1' },
    ];

    toggleCard() {
        this.showCard = !this.showCard;
    }

    resetForm() {
        this.validatedValue = '-1';

        this.rerenderDT();
        this.showCard = true;
    }

    applyFilters(): void {
        this.rerenderDT(true);
    }

    dtLink =
        environment.interop.basePath +
        environment.interop.platform.nomenclatoare.beneficiar.getBeneficiariDT;

    constructor(
        private http: HttpClient,
        private dialog: MatDialog,
        private dialogService: DialogService,
        private beneficiariService: BeneficiariService
    ) { }

    ngOnInit(): void {
        this.renderDT();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    renderDT() {
        this.isLoading = true;
        this.dtOptions = {
            serverSide: true,
            searching: false,
            pageLength: 25,
            responsive: true,
            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;
                // dataTablesParameters.param1 = this.activeValue;
                // dataTablesParameters.param2 = this.publicValue;
                // dataTablesParameters.param1 = this.validatedValue;

                this.http
                    .post<DataTablesResponse>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columns: [
                {
                    title: 'ID',
                    data: 'id',
                },
                {
                    title: 'Nume',
                    data: 'nume',
                },
                {
                    title: 'Prenume',
                    data: 'prenume',
                },
                {
                    title: 'Denumire companie',
                    data: 'denumire',
                },
                {
                    title: 'Acțiuni',
                    className: 'all',
                    data: null,
                    orderable: false,
                    render: () => {
                        return `
                <div class="d-flex align-center justify-content-center">
                            <button class="action-btn view ms-1">
                                <img class="btn-img" src="../../../../assets/icons/view.svg" alt="view"/>
                            </button>
                            </div>
                        `;
                    },
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                const lastTd = (row as HTMLElement).querySelector('td:last-child');
                const validateIcon = lastTd?.querySelector('.validate');
                const viewicon = lastTd?.querySelector('.view');

                // if (validateIcon) {
                //     validateIcon.addEventListener('click', () => {
                //         // this.openEditDialog(data);
                //     });
                // }

                if (viewicon) {
                    viewicon.addEventListener('click', () => {
                        this.openInfoDialog(data);
                    });
                }

                return row;
            },
        };
    }

    rerenderDT(paginate = false): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw(paginate);
        });
        this.showCard = false;
    }

    openInfoDialog(data: IBeneficiarInfo) {
        const dialogRef = this.dialog.open(InfoBeneficiarComponent, {
            minHeight: '100vh',
            maxHeight: '100vh',
            minWidth: '100vw',
            maxWidth: '100vw',
            disableClose: true,
            data,
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.rerenderDT();
            }
        });
    }
}
